import { supportedCurrencies, supportedLocales } from '../config';
export default [
    {
        key: 'data',
        components: [
            {
                key: 'currency',
                label: 'Currency',
                type: 'select',
                validate: {
                    required: true,
                },
                defaultValue: 'EUR',
                data: {
                    values: supportedCurrencies
                },
            },
            {
                key: 'locale',
                label: 'Locale',
                type: 'select',
                validate: {
                    required: true,
                },
                defaultValue: 'nl-nl',
                data: {
                    values: supportedLocales,
                },
            },
            {
                label: 'Product list',
                key: 'product_list',
                validate: {
                    custom: "function isIdUnique(arr) {\n  const seenIds = {};\n  for (const obj of arr) {\n    if (seenIds[obj.id]) {\n      return 'ID needs to be unique.';\n    }\n    seenIds[obj.id] = true;\n  }\n  return true;\n}\n\nvalid = isIdUnique(row[component.key]);"
                },
                templates: {
                    header: '' +
                        '<div class="row">' +
                        '<div class="col-sm-2"></div>' +
                        '  {% util.eachComponent(components, function(component) { %} ' +
                        '   {% if (!component.hideInTable) { %}' +
                        '    <div class="col-sm-4">' +
                        '      <strong>{{ component.label }}</strong>' +
                        '    </div>' +
                        '        {% } %}' +
                        '  {% }) %}' +
                        '</div>',
                    row: '' +
                        '<div class="row">' +
                        '<div class="col-sm-2"><button data-key="editgrid-defaultValue" class="formio-drag-button btn btn-default fa fa-bars" type="button"></button></div>' +
                        '  {%util.eachComponent(components, function(component) { %}' +
                        '     {% if (!component.hideInTable) { %}' +
                        '       <div class="col-sm-4">' +
                        '         {% if (typeof row[component.key] === "boolean") { %}' +
                        '           <i class="fa fa-{{ (row[component.key] ? "check" : "times") }}"></i>' +
                        '         {% } else { %}' +
                        '           {{ row[component.key] }}' +
                        '         {% } %}' +
                        '       </div>' +
                        '     {% } %}' +
                        '  {% }) %}' +
                        '  <div class="col-sm-2">' +
                        '    <div class="btn-group pull-right">' +
                        '      <div class="btn btn-default btn-sm editRow"><i class="fa fa-edit"></i></div>' +
                        '      <div class="btn btn-danger btn-sm removeRow"><i class="fa fa-trash"></i></div>' +
                        '    </div>' +
                        '  </div>' +
                        '</div>',
                    footer: '',
                },
                type: 'rowgrid',
                input: true,
                components: [
                    {
                        label: 'Icon URL',
                        key: 'icon_url',
                        input: true,
                        type: 'textfield',
                        hideInTable: true,
                    },
                    {
                        label: 'Columns Id-Label',
                        columns: [
                            {
                                components: [
                                    {
                                        label: 'Label',
                                        key: 'label',
                                        input: true,
                                        type: 'textfield',
                                        validate: {
                                            required: true,
                                        },
                                    },
                                ],
                                width: 4,
                                offset: 0,
                                push: 0,
                                pull: 0,
                                size: 'md',
                                currentWidth: 6,
                            },
                            {
                                components: [
                                    {
                                        label: 'ID',
                                        key: 'id',
                                        input: true,
                                        type: 'textfield',
                                        tableView: false,
                                        tooltip: 'The ID is automatically generated depending on the input of the product label.\nTo use a custom ID, you can adjust the field accordingly.',
                                        redrawOn: 'label',
                                        calculateValue: "function sanitizeInput(input) {\n  // Convert input to lowercase\n  let sanitized = input.toLowerCase();\n  \n  // Replace spaces with underscores and remove non-alphanumeric characters except underscores\n  sanitized = sanitized.replace(/\\s+/g, '_').replace(/[^a-z0-9_]/g, '');\n  \n  // Convert underscores to camelCase\n  sanitized = sanitized.replace(/_([a-z])/g, (match, p1) => p1.toUpperCase());\n\n  // Truncate to 32 characters if necessary\n  if (sanitized.length > 32) {\n    sanitized = sanitized.substring(0, 32);\n  }\n\n  return sanitized;\n}\n\nvalue = sanitizeInput(row.label)",
                                        allowCalculateOverride: true,
                                        validate: {
                                            required: true,
                                            minLength: 1,
                                            maxLength: 32,
                                            minWords: 1,
                                            maxWords: 32
                                        },
                                    },
                                ],
                                width: 8,
                                offset: 0,
                                push: 0,
                                pull: 0,
                                size: 'md',
                                currentWidth: 6,
                            },
                        ],
                        key: 'columns_id_label',
                        type: 'columns',
                        input: false,
                        tableView: false,
                    },
                    {
                        label: 'Description',
                        key: 'description',
                        input: true,
                        type: 'textarea',
                        hideInTable: true,
                        tableView: false,
                    },
                    {
                        type: 'checkbox',
                        input: true,
                        key: 'checked',
                        label: 'Checked by default',
                        hideInTable: true,
                    },
                    // < START > Quantity Discount
                    {
                        type: 'checkbox',
                        input: true,
                        key: 'quantity_discount',
                        label: 'Quantity discount',
                        hideInTable: true,
                    },
                    {
                        hideInTable: true,
                        label: 'Tiers',
                        key: 'quantity_discount_tiers',
                        validate: {
                            custom: "function isSequentialRange(arr) {\n  // Check if the array has at least two elements to compare\n  if (arr.length <= 1) return true;\n\n  // Use _.every to iterate, starting from the second element (index 1)\n  return _.every(arr, (currentObj, index) => {\n    if (index === 0) return true; // Skip the first object, as it has nothing to compare to\n\n    const prevObj = arr[index - 1];\n    // Check if current object's minRange is exactly one more than the previous object's maxRange\n    return currentObj.quantity_discount_min_products === prevObj.quantity_discount_max_products + 1;\n  });\n}\n\nvalid = (isSequentialRange(row[component.key])) ? true : 'The minimum range for each tier must be greater than the maximum range of the previous tier, plus one, except for the first entry.'"
                        },
                        templates: {
                            header: '' +
                                '<div class="row">' +
                                ' {% util.eachComponent(components, function(component) { %} ' +
                                '   {% if (!component.hideInParent) { %}' +
                                '     <div class="col-sm-3">' +
                                '       <strong>{{ component.label }}</strong>' +
                                '     </div>' +
                                '   {% } %}' +
                                ' {% }) %}' +
                                '</div>',
                            row: '' +
                                '<div class="row">' +
                                '  {% util.eachComponent(components, function(component) { %}' +
                                '     {% if (!component.hideInParent) { %}' +
                                '       <div class="col-sm-3">' +
                                '         {% if (typeof row[component.key] === "boolean") { %}' +
                                '           <i class="fa fa-{{ (row[component.key] ? "check" : "times") }}"></i>' +
                                '         {% } else { %}' +
                                '           {{ row[component.key] }}' +
                                '         {% } %}' +
                                '       </div>' +
                                '     {% } %}' +
                                '  {% }) %}' +
                                '  <div class="col-sm-3">' +
                                '    <div class="btn-group pull-right">' +
                                '      <div class="btn btn-default btn-sm editRow"><i class="fa fa-edit"></i></div>' +
                                '      <div class="btn btn-danger btn-sm removeRow"><i class="fa fa-trash"></i></div>' +
                                '    </div>' +
                                '  </div>' +
                                '</div>',
                            footer: '',
                        },
                        type: 'rowgrid',
                        input: true,
                        components: [
                            {
                                label: 'Columns min-max',
                                columns: [
                                    {
                                        components: [
                                            {
                                                label: 'Minimum products',
                                                key: 'quantity_discount_min_products',
                                                input: true,
                                                type: 'number',
                                                hideInTable: true,
                                                hideInParent: true,
                                                validate: {
                                                    required: true,
                                                    min: 1,
                                                    max: 9999,
                                                },
                                            },
                                        ],
                                        width: 6,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 6,
                                    },
                                    {
                                        components: [
                                            {
                                                label: 'Maximum products',
                                                key: 'quantity_discount_max_products',
                                                input: true,
                                                type: 'number',
                                                hideInTable: true,
                                                hideInParent: true,
                                                validate: {
                                                    required: true,
                                                    min: 1,
                                                    max: 9999,
                                                },
                                            },
                                        ],
                                        width: 6,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 6,
                                    },
                                ],
                                key: 'columns_min_max_products',
                                type: 'columns',
                                input: false,
                                tableView: false,
                            },
                            {
                                label: 'Tier Range',
                                persistent: false,
                                redrawOn: 'data',
                                key: 'tierRange',
                                type: 'hidden',
                                input: true,
                                tableView: false,
                                hideInTable: true,
                                hideInParent: false,
                                calculateValue: 'value = row.quantity_discount_min_products + \"-\" + row.quantity_discount_max_products',
                            },
                            {
                                label: 'Amount (in cents)',
                                key: 'quantity_discount_amount_cents',
                                input: true,
                                type: 'number',
                                hideInTable: true,
                                hideInParent: false,
                                validate: {
                                    required: true,
                                },
                            },
                            {
                                label: 'Columns min-max',
                                columns: [
                                    {
                                        components: [
                                            {
                                                label: 'Shipping amount (in cents)',
                                                key: 'quantity_discount_shipping_amount_cents',
                                                input: true,
                                                type: 'number',
                                                hideInTable: true,
                                                hideInParent: false,
                                            }
                                        ],
                                        width: 4,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 4,
                                    },
                                    {
                                        components: [
                                            {
                                                label: 'Shipping amount label',
                                                key: 'quantity_discount_shipping_amount_label',
                                                input: true,
                                                type: 'textfield',
                                                tableView: false,
                                                hideInTable: true,
                                                hideInParent: true,
                                            },
                                        ],
                                        width: 8,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 8,
                                    },
                                ],
                                key: 'columns_shipping_cost',
                                type: 'columns',
                                input: false,
                                tableView: false,
                            },
                        ],
                        conditional: {
                            show: true,
                            when: 'product_list.quantity_discount',
                            eq: 'true',
                        },
                    },
                    // < END /> Quantity Discount
                    // < START > Products
                    {
                        key: 'products',
                        type: 'fieldset',
                        label: 'Field Set',
                        input: false,
                        tableView: false,
                        conditional: {
                            show: true,
                            when: 'product_list.quantity_discount',
                            eq: 'false',
                        },
                        components: [
                            {
                                type: 'checkbox',
                                input: true,
                                key: 'fixed_amount',
                                label: 'Fixed amount',
                                hideInTable: true,
                                tooltip: 'Enable for fixed product amount',
                            },
                            {
                                type: 'checkbox',
                                input: true,
                                key: 'allow_multiple',
                                label: 'Allow Multiple',
                                tooltip: 'Allow Multiple',
                                hideInTable: true,
                                conditional: {
                                    show: true,
                                    when: 'product_list.fixed_amount',
                                    eq: 'true',
                                },
                            },
                            {
                                label: 'Columns min-max products',
                                columns: [
                                    {
                                        components: [
                                            {
                                                label: 'Minimum products',
                                                key: 'quantity_min',
                                                input: true,
                                                type: 'number',
                                                hideInTable: true,
                                                conditional: {
                                                    show: true,
                                                    when: 'product_list.allow_multiple',
                                                    eq: 'true',
                                                },
                                            },
                                        ],
                                        width: 6,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 6,
                                    },
                                    {
                                        components: [
                                            {
                                                label: 'Maximum products',
                                                key: 'quantity_max',
                                                input: true,
                                                type: 'number',
                                                hideInTable: true,
                                                conditional: {
                                                    show: true,
                                                    when: 'product_list.allow_multiple',
                                                    eq: 'true',
                                                },
                                            },
                                        ],
                                        width: 6,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 6,
                                    },
                                ],
                                key: 'columns_min_max_products',
                                type: 'columns',
                                input: false,
                                tableView: false,
                            },
                            {
                                label: 'Amount per item (in cents)',
                                key: 'amount',
                                input: true,
                                type: 'number',
                                hideInTable: true,
                                validate: {
                                    required: true,
                                },
                                conditional: {
                                    show: true,
                                    when: 'product_list.fixed_amount',
                                    eq: 'true',
                                },
                            },
                            {
                                label: 'Columns min-max amount',
                                columns: [
                                    {
                                        components: [
                                            {
                                                label: 'Min amount (in cents)',
                                                key: 'amount_min',
                                                input: true,
                                                type: 'number',
                                                hideInTable: true,
                                                conditional: {
                                                    show: false,
                                                    when: 'product_list.fixed_amount',
                                                    eq: 'true',
                                                },
                                            },
                                        ],
                                        width: 6,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 6,
                                    },
                                    {
                                        components: [
                                            {
                                                label: 'Max amount (in cents)',
                                                key: 'amount_max',
                                                input: true,
                                                type: 'number',
                                                hideInTable: true,
                                                conditional: {
                                                    show: false,
                                                    when: 'product_list.fixed_amount',
                                                    eq: 'true',
                                                },
                                            },
                                        ],
                                        width: 6,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 6,
                                    },
                                ],
                                key: 'columns_min_max',
                                type: 'columns',
                                input: false,
                                tableView: false,
                            },
                            {
                                label: 'Columns shipping',
                                conditional: {
                                    show: true,
                                    when: 'product_list.fixed_amount',
                                    eq: 'true',
                                },
                                columns: [
                                    {
                                        components: [
                                            {
                                                label: 'Shipping amount (in cents)',
                                                key: 'shipping_amount_cents',
                                                input: true,
                                                type: 'number',
                                                hideInTable: true,
                                                hideInParent: false,
                                            },
                                        ],
                                        width: 4,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 4,
                                    },
                                    {
                                        components: [
                                            {
                                                label: 'Shipping amount label',
                                                key: 'shipping_amount_label',
                                                input: true,
                                                type: 'textfield',
                                                tableView: false,
                                                hideInTable: true,
                                                hideInParent: true,
                                            },
                                        ],
                                        width: 8,
                                        offset: 0,
                                        push: 0,
                                        pull: 0,
                                        size: 'md',
                                        currentWidth: 8,
                                    },
                                ],
                                key: 'columns_shipping',
                                type: 'columns',
                                input: false,
                                tableView: false,
                            },
                        ]
                    },
                ],
            },
            {
                key: 'multiple',
                ignore: true
            },
            {
                key: 'defaultValue',
                ignore: true
            },
            {
                key: 'persistent',
                ignore: true
            },
            {
                key: 'protected',
                ignore: true
            },
            {
                key: 'dbIndex',
                ignore: true
            },
            {
                key: 'calculateServer',
                ignore: true
            },
            {
                key: 'calculateValuePanel',
                ignore: true
            },
            {
                key: 'customDefaultValuePanel',
                ignore: true
            },
            {
                key: 'encrypted',
                ignore: true,
            },
        ]
    },
];
